/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Schema for the list of resources.
 */
export interface ListCredentialSchema {
    /** The list of resources. */
    items: Truvity.ResourceCredentialSchema[];
}
